/**
 * @generated SignedSource<<1fafbe3f5e59cfa1cc79ff36d14da926>>
 * @relayHash f7e88b121b5e2b46eeaa31ff8cc92d5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf8db5c270af2d039d8f9d28d2367431567cbf17cfe6383d2d8ed25721e15a0a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubBootstrapWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  operationType?: HelpCenterMediaConfigOperationType | null;
  pageAri: string;
  skipPageMediaConfig: boolean;
};
export type hubBootstrapWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubBootstrapWrapperQuery = {
  response: hubBootstrapWrapperQuery$data;
  variables: hubBootstrapWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPageMediaConfig"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v7 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubBootstrapWrapperQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "pageAri",
                "variableName": "pageAri"
              },
              {
                "kind": "Variable",
                "name": "skipPageMediaConfig",
                "variableName": "skipPageMediaConfig"
              }
            ],
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubBootstrapWrapperQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v7/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          {
            "condition": "skipPageMediaConfig",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "pageMediaConfig",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "ari",
                    "variableName": "pageAri"
                  },
                  (v7/*: any*/)
                ],
                "concreteType": "HelpCenterMediaConfig",
                "kind": "LinkedField",
                "name": "hubMediaConfig",
                "plural": false,
                "selections": (v8/*: any*/)
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "helpCenterAri",
                "variableName": "hubAri"
              }
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "secondaryColor"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterNavigationBar",
                        "kind": "LinkedField",
                        "name": "navigationBar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "backgroundColor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "borderColor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "borderType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cornerRadius"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "padding"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "positionType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "textColor"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bf8db5c270af2d039d8f9d28d2367431567cbf17cfe6383d2d8ed25721e15a0a",
    "metadata": {},
    "name": "hubBootstrapWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "174240bce1a74f3153918fadfb8c8cce";

export default node;
